import http from './http'
import Vue from 'vue'
/*
 * @Author: zly
 * @Date: 2021-07-20 13:45:37
 * @LastEditTime: 2022-02-11 09:31:55
 * @LastEditors: 汪俊洪
 * @Description:文件流生成
 * @Params haveMsg 后台是否会返回错误提示
 */
const exportFun = ({ url = '', params = {}, name = '列表.xls', type = 'application/json', haveMsg = false }) => {
  // eslint-disable-next-line promise/param-names
  return new Promise((resolve) => {
    http
      .post(url, params, {
        responseType: 'blob'
      })
      .then(({ data: res }) => {
        if (haveMsg) {
          if (res.size > 0) {
            // const that = this
            const reader = new FileReader()
            reader.onload = e => {
              if (e.target.result.indexOf('"code":') === -1) {
                download(res, type, name)
                resolve(true)
              } else {
                const data = JSON.parse(e.target.result)
                if (data.code !== 0) {
                  Vue.prototype.$message.error(data.message || '下载失败')
                }
                resolve(false)
              }
            }
            reader.readAsText(res)
          }
          resolve()
        } else {
          download(res, type, name)
          resolve(true)
        }
      })
  })
}

function download (res, type, name) {
  const blob = new Blob([res], { type: type || res.type })
  const fileName = name // xlsx
  const elink = document.createElement('a')
  elink.download = fileName
  elink.style.display = 'none'
  elink.href = URL.createObjectURL(blob)
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
}
export default exportFun
